export const allColors = {
  colorBlack: '#000000',
  colorGrayBorder: '#E8E8E8',
  colorGrayComponents: '#F9F9FB',
  colorGrayHover: '#F4F4F4',
  colorGrayDisabled: '#BBBBBB',
  colorGrayCard: '#F7F7F8',
  colorGrayText: '#696158',
  colorGrayCardDashed: '#D7D9D9',
  colorGrayLineDashed: '#BABABA',
  colorGrayStep: '#A29D98',
  colorGreen: '#00A499',
  colorGreensuccess: ' #00ae12',
  colorGreenBalance: '#00AE99',
  colorGreenHover: '#059F8D',
  colorGreenSelectCard: '#EEFBF9',
  colorPinkCardBackground: '#ffe5d9',
  colorOrangeHover: '#EA4800',
  colorOrangeMain: '#FF4F00',
  colorOrangeMainActive: '#F04C02',
  colorRedError: '#FF4B4B',
  colorTooltip: '#C4C4C4',
  colorWhiteBase: '#FFFFFF',
  colorPlaceholder: '#9D9994',
  colorGrayLight: '#d6d6d6',
  colorBlueInfo: '#0049bf',
};
